import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DropdownButton, DropdownButtonContext, FieldText, } from '@dixa/lib-shared-habla';
import { Component } from 'react';
class BasicAuthForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdateUsername = this.handleUpdateUsername.bind(this);
        this.handleUpdatePassword = this.handleUpdatePassword.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        const { onSubmit, toggleDropdown } = this.props;
        const { username, password } = this.state;
        onSubmit(window.btoa(`${username}:${password}`));
        toggleDropdown();
        this.setState({
            username: '',
            password: '',
        });
    }
    handleUpdateUsername(event) {
        this.setState({
            username: event.target.value,
        });
    }
    handleUpdatePassword(event) {
        this.setState({
            password: event.target.value,
        });
    }
    handleKeyDown(event) {
        if (event.key === 'Enter') {
            this.handleSubmit(event);
        }
    }
    render() {
        const { username, password } = this.state;
        return (_jsxs("div", Object.assign({ onKeyDown: this.handleKeyDown, className: "fetchdata-modal-auth" }, { children: [_jsx("h2", { children: "Basic authentication" }), _jsx("p", { children: "Fill in your username and password to create a basic authentication header." }), _jsx(FieldText, { className: "fetchdata-modal-auth__field", label: "Username", input: { value: username, onChange: this.handleUpdateUsername }, meta: {}, placeholder: "user" }), _jsx(FieldText, { className: "fetchdata-modal-auth__field", label: "Password", input: { value: password, onChange: this.handleUpdatePassword }, meta: {}, type: "password", placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" }), _jsx(Button, Object.assign({ type: "submit", onClick: this.handleSubmit }, { children: "Go" }))] })));
    }
}
const AuthGeneratorComponent = ({ fields }) => {
    const insertHeader = (base64string) => {
        fields.push({ key: 'Authorization', value: `Basic ${base64string}` });
    };
    return (_jsx(DropdownButton, Object.assign({ buttonProps: { variant: 'tertiary' }, dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsx(BasicAuthForm, { toggleDropdown: toggleDropdown, onSubmit: insertHeader })) }) }, { children: "Basic auth" })));
};
export default AuthGeneratorComponent;
